import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, MAP_EMBED, buildWhatsAppLink } from "../lib/site";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" {...props}>
    <path d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1 0-5.18c.27 0 .53.04.77.12V9.66a6 6 0 0 0-.77-.05A5.68 5.68 0 1 0 15.5 15.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.2-1.48z" />
  </svg>
);

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" {...props}>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm5.8 14.13c-.25.7-1.44 1.33-1.98 1.38-.53.05-1.02.24-3.44-.72-2.9-1.14-4.75-4.09-4.9-4.28-.14-.19-1.17-1.56-1.17-2.97 0-1.41.74-2.1 1-2.39.25-.29.55-.36.73-.36.18 0 .37 0 .53.01.17.01.4-.06.63.48.25.58.83 2 .9 2.15.07.14.12.31.02.5-.09.19-.14.31-.28.48-.14.16-.29.36-.42.48-.14.14-.29.29-.12.57.17.29.74 1.22 1.59 1.98 1.09.97 2.01 1.27 2.3 1.42.29.14.46.12.63-.07.17-.19.72-.85.91-1.14.19-.29.38-.24.64-.14.26.09 1.66.79 1.94.93.29.14.48.21.55.33.07.12.07.7-.18 1.4z" />
  </svg>
);

const DISCLAIMER =
  "A Inove Tech é uma empresa independente especializada em serviços para celulares e outros dispositivos. Não possui vínculo comercial, autorização, credenciamento ou representação oficial da Apple Inc., Samsung Electronics, Motorola Mobility, Xiaomi Corporation ou quaisquer outros fabricantes. As marcas mencionadas pertencem aos seus respectivos proprietários e são utilizadas exclusivamente para identificar os aparelhos e dispositivos atendidos.";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#000000] border-t border-white/[0.06] pt-20 pb-10"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <Logo size={28} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Empresa */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#86868b] mb-6">
              Empresa
            </h3>
            <ul className="space-y-3.5 text-[15px]">
              <li>
                <Link data-testid="footer-quem-somos" to="/quem-somos" className="text-[#f5f5f7]/80 hover:text-[#f5f5f7] transition-colors">Quem Somos</Link>
              </li>
              <li>
                <Link data-testid="footer-garantia" to="/garantia" className="text-[#f5f5f7]/80 hover:text-[#f5f5f7] transition-colors">Garantia</Link>
              </li>
              <li>
                <Link data-testid="footer-privacidade" to="/politica-de-privacidade" className="text-[#f5f5f7]/80 hover:text-[#f5f5f7] transition-colors">Política de Privacidade</Link>
              </li>
              <li>
                <Link data-testid="footer-cookies" to="/politica-de-cookies" className="text-[#f5f5f7]/80 hover:text-[#f5f5f7] transition-colors">Política de Cookies</Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#86868b] mb-6">
              Contato
            </h3>
            <ul className="space-y-3.5 text-[15px] text-[#f5f5f7]/80">
              <li>
                <a data-testid="footer-whatsapp" href={buildWhatsAppLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#f5f5f7] transition-colors">
                  <WhatsAppIcon /> WhatsApp
                </a>
              </li>
              <li>
                <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#f5f5f7] transition-colors">
                  <Instagram size={18} /> Instagram
                </a>
              </li>
              <li>
                <a data-testid="footer-tiktok" href={CONTACT.tiktok} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#f5f5f7] transition-colors">
                  <TikTokIcon /> TikTok
                </a>
              </li>
              <li>
                <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 hover:text-[#f5f5f7] transition-colors">
                  <Mail size={18} /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-2 pt-2 text-[#86868b]">
                <MapPin size={18} className="shrink-0 mt-0.5" />
                <span>{CONTACT.address}</span>
              </li>
              <li className="flex items-start gap-2 text-[#86868b]">
                <Clock size={18} className="shrink-0 mt-0.5" />
                <span>{CONTACT.hours.join(" · ")}</span>
              </li>
            </ul>
          </div>

          {/* Informações da Empresa */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#86868b] mb-6">
              Informações da Empresa
            </h3>
            <ul className="space-y-3.5 text-[15px] text-[#f5f5f7]/80">
              <li>Razão Social: {CONTACT.company.razaoSocial}</li>
              <li>CNPJ: {CONTACT.company.cnpj}</li>
              <li>{CONTACT.company.city}</li>
            </ul>
          </div>

          {/* Localização */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#86868b] mb-6">
              Localização
            </h3>
            <div className="rounded-2xl overflow-hidden border border-white/[0.06]">
              <iframe
                title="Localização Inove Tech - rodapé"
                src={MAP_EMBED}
                width="100%"
                height="160"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="map-dark"
                data-testid="footer-map"
              />
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-16 pt-8 border-t border-white/[0.06]">
          <p
            data-testid="footer-disclaimer"
            className="text-[12px] leading-relaxed text-[#86868b] max-w-4xl"
          >
            {DISCLAIMER}
          </p>
          <p className="mt-6 text-[12px] text-[#86868b]/70">
            © {new Date().getFullYear()} Inove Tech. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
